// 手机
// const RegexPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
const RegexPhone = /^(0|86|17951)?1[0-9]{10}$/;
// 邮箱
const RegEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
// 密码 必须是字母数字组合
const RegPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
// 验证码 4位
const RegCode = /^\d+$/;
// 身份证
const RegIdNum = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/;
// 银行卡 16或
const RegBankNum = /^\d+$/;
const RegBankNum3 = /^\d{19}$/;
// 银行卡 16位 带空格
const RegBankNum2 = /^\d{4}(?:\s\d{4}){3}$/;
// 匹配姓名 中文 2-4个字符
// const RegName = /^([\u4e00-\u9fa5\ ]{2,4})$/;
const RegName = /^[\u4e00-\u9fa5]+$/;
// 必须数字
const RegIsNum = /^\d+$/;
// 正整数
const RegPINum = /^[1-9]\d*$/;
// 确认密码
let chekPass = '';

// 不能为空
export const VaName = (rule, value, callback) => {
  let key = '姓名';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'id':
      key = '身份证号';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'groupPapersNum':
      key = '企业证件号码';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '企业对公银行账号';
      break;
    case 'bank':
      key = '企业银行开户行名称';
      break;
    case 'subbranch':
      key = '企业银行账号开户支行全称';
      break;
    case 'selectedOptions':
      key = '营业地址不能为空';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (RegName.test(value)) {
      callback();
    } else if (rule.field === 'selectedOptions') {
      if (value.length === 0) {
        callback(new Error(`${key}不能为空`));
      } else {
        callback();
      }
    } else {
      callback(new Error(`${key}格式错误`));
    }
  }
};
// 控制长度不控制内容
export const VaLength = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'id':
      key = '身份证号';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'groupPapersNum':
      key = '企业证件号码';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '企业对公银行账号';
      break;
    case 'bank':
      key = '企业银行账号开户行名称';
      break;
    case 'subbranch':
      key = '企业银行账号开户行支行全称';
      break;
    case 'selectedOptions':
      key = '企业银行开户行地区';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (rule.field === 'groupName' || rule.field === 'bankAccount' || rule.field === 'bank' || rule.field === 'subbranch') {
      if (value.length > 50) {
        callback(new Error(`${key}格式错误,长度不能超过50`));
      }
    } else if (value.length > 20) {
      callback(new Error(`${key}格式错误,长度不能超过20`));
    }
  }
};
// 验证普通登录账号
export const ValidateGLName = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'phone':
      key = '手机号';
      break;
    case 'mail':
      key = '邮箱号';
      break;
  }
  if (!value) {
    callback(new Error('账号不能为空'));
  } else {
    if (rule.field === 'phone') {
      if (RegexPhone.test(value)) {
        callback();
      } else {
        callback(new Error('手机号格式不正确'));
      }
    } else if (rule.field === 'mail') {
      if (RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error('邮箱号格式不正确'));
      }
    } else {
      if (RegexPhone.test(value) || RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error('账号格式不正确请重新输入'));
      }
    }
  }
};

// 验证普通登录密码
export const ValidateGLPassword = (rule, value, callback) => {
  if (!value) {
    callback(new Error('密码不能为空'));
  } else {
    if (RegPass.test(value)) {
      chekPass = value;
      callback();
    } else {
      callback(new Error('必须包含字母和数字，长度为6-20个字符，不支持特殊字符'));
    }
  }
};

// 确认密码
export const ValidateChekPassword = (rule, value, callback) => {
  if (!value) {
    callback(new Error('密码不能为空'));
  } else {
    if (chekPass === value) {
      callback();
    } else {
      callback(new Error('两次输入密码不一致!'));
    }
  }
};

// 快速登录 手机验证
export const VaPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('手机号不能为空'));
  } else {
    if (RegexPhone.test(value)) {
      callback();
    } else {
      callback(new Error('手机号格式不正确请重新输入'));
    }
  }
};

// 验证码 验证
export const VaCode = (rule, value, callback) => {
  if (!value) {
    callback(new Error('验证码不能为空'));
  } else {
    if (RegCode.test(value)) {
      callback();
    } else {
      callback(new Error('验证码格式错误，请重新输入'));
    }
  }
};

// 年龄
export const IdAge = (vaId) => {
  let date = new Date();
  let bYear =  Number(vaId.substr(6, 4));
  let bMonth = Number(vaId.substr(10, 2));
  let bDate = Number(vaId.substr(12, 2));
  let nYear = Number(date.getFullYear());
  let nMonth =Number(date.getMonth() + 1);
  let nDate = Number(date.getDate());
  if (nDate < bDate) {
    nMonth -= 1;
  }
  if (nMonth < bMonth) {
    nYear -= 1;
  }
  return nYear - bYear
}

// 身份证验证
export const VaId = (rule, value, callback) => {
  let key = '身份证号码';
  switch (rule.field) {
    case 'legalIdno':
      key = '法人身份证号';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (RegIdNum.test(value)) {
      if (IdAge(value) < 18) {
        callback(new Error('很遗憾，您未满18周岁，根据国家相关法律法规要求，e签宝暂无法为您提供电子合同服务'));
      } else {
        callback();
      }
    } else {
      callback(new Error('身份证号码错误，请重新输入'));
    }
  }
};


// 银行卡验证
export const VaBankNum = (rule, value, callback) => {
  if (!value) {
    callback(new Error('银行卡号不能为空'));
  } else {
    if (value.lenght > 50) {
      callback(new Error('银行卡号错误，请重新输入'));
    }
    if (RegBankNum.test(value) || RegBankNum2.test(value) || RegBankNum3.test(value)) {
      callback();
    } else {
      callback(new Error('银行卡号错误，请重新输入'));
    }
  }
};

// 必须是数字
export const VaIsNum = (rule, value, callback) => {
  let key = '金额';
  switch (rule.field) {
    case 'groupPapersNum':
      key = '企业证件号';
      break;
    case 'cardno':
      key = '对公账户';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (RegIsNum.test(value)) {
      callback();
    } else {
      callback(new Error(`${key}格式错误，请重新输入`));
    }
  }
};

// 用户中心 合同截止日期 校验
export const VaIsNumLess1 = (rule, value, callback) => {
  let key = '';
  if (!value) {
    callback(new Error(`${key}不能为空，最小是1`));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error(`最小天数是1`));
      } else if (value > 15) {
        callback(new Error('最大天数15'));
      } else {
        callback();
      }
    } else {
      callback(new Error(`${key}格式错误，请重新输入`));
    }
  }
};
// 用户中心 合同有效日期 校验
export const VaIsNumLess2 = (rule, value, callback) => {
  let key = '';
  if (!value) {
    callback(new Error(`${key}不能为空，最小是1`));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error(`最小天数是1`));
      } else if (value > 100) {
        callback(new Error('最大天数100'));
      } else {
        callback();
      }
    } else {
      callback(new Error(`${key}格式错误，请重新输入`));
    }
  }
};
// 骑缝页面设置 校验
export const VaPagingSeal = (rule, value, callback) => {
  let key = '';
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (RegIsNum.test(value)) {
      if (value < 1) {
        callback(new Error(`最小页数是1`));
      } else {
        callback();
      }
    } else {
      callback(new Error(`${key}格式错误，请重新输入`));
    }
  }
};

// 不能为空
export const VaIsBlank = (rule, value, callback) => {
    let key = '';
    switch (rule.field) {
      case 'password':
        key = '密码';
        break;
      case 'bankNum':
        key = '开户银行账号';
    }
    if (rule.field === 'password') {
      if (!value) {
        callback(new Error(`${key}不能为空`));
      } else {
        callback();
      }
    } else if (rule.field === 'bankNum') {
      if (!value) {
        callback(new Error(`${key}不能为空`));
      }
      if (value.length > 50) {
        callback(new Error(`${key}长度不能超过50`));
      }
      if (/^[A-Za-z0-9]+$/.test(value)) {
        callback();
      } else {
        callback(new Error(`${key}格式不正确`));
      }
    }
  }
;

// checkbox 选择不能为空
export const VaCheckboxBlank = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'organType':
      key = '企业类型';
      break;
    case 'licenseType':
      key = '证件类型';
      break;
    case 'legalArea':
      key = '法人代表归属地';
      break;
    case 'userType':
      key = '填写人身份';
      break;
  }
  if (value === '' || value.length === 0) {
    callback(new Error(`${key}不能为空`));
  } else {
    callback();
  }
};
// 上传图片不能为空
export const VaPhotoBlank = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'organType':
      key = '企业类型';
      break;
    case 'licenseType':
      key = '证件类型';
      break;
    case 'legalArea':
      key = '法人代表归属地';
      break;
    case 'userType':
      key = '填写人身份';
      break;
  }
  if (value === '') {
    callback(new Error(`${key}不能为空`));
  } else {
    callback();
  }
};
// 验证邮箱和手机号
export const checkPhoneEmail = (rule, value, callback) => {
  if (!value) {
    callback(new Error('手机号或邮箱不能为空'));
  } else {
    if (value.length > 36) {
      callback(new Error('手机号或邮箱最大长度不超过36个字符'));
    }
    if (RegexPhone.test(value) || RegEmail.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的手机号／邮箱号'));
    }
  }
};

// 验证企业名称／姓名
export const checkNickName = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入企业名称／姓名'));
  } else {
    if (value.length < 2 || value.length > 80) {
      callback(new Error('企业名称／姓名长度在 2 到 80 个字符'));
    } else {
      callback();
    }
  }
};

// 个人自动实名 姓名 validate
export const personalRealName = (rule, value, callback) => {
  if (!value) {
    callback(new Error('姓名不能为空'));
  } else {
    if (value.length < 2 || value.length > 80) {
      callback(new Error('姓名长度在 2 到 80 个字符'));
    } else {
      callback();
    }
  }
};

// 非三证合一 组织机构代码
const RegOrganCode = /^([0-9A-Z]){8}[-]?[0-9A-Z]$/;
export const checkOrganCode = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入组织机构代码'));
  } else {
    if (RegOrganCode.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的组织机构代码'));
    }
  }
};

// 三证合一 统一社会信用代码
// const RegOrganCode3 = /^\d{18}$/;
const RegOrganCode3 = /^([0-9A-Z]{2})([0-9]{6})([0-9A-Z]){10}$/;
export const checkOrganCode3 = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'organCodeThree':
      key = '统一社会信用代码'
  }
  if (!value) {
    callback(new Error(`请输入${key}`));
  } else {
    if (RegOrganCode3.test(value)) {
      callback();
    } else {
      callback(new Error(`请输入正确的${key}`));
    }
  }
};
// 工商注册号 regCode
// const RegRegCode = /^\d{15}$/;
const RegRegCode = /^\w{0,40}$/;
export const checkRegCode = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'regCode0':
      key = '注册号';
      break;
    case 'regCode1':
      key = '社证号';
      break;
    case 'regCode2':
      key = '事证号';
      break;
    case 'regCode3':
      key = '民证字号';
      break;
    case 'regCode4':
      key = '执法证号';
      break;
  }
  if (!value) {
    callback(new Error(`请输入${key}`));
  } else {
    if (RegRegCode.test(value)) {
      callback();
    } else {
      callback(new Error(`请输入正确的${key}`));
    }
  }
};

// 长度校验 1 - 50
export const checkNameLength = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'name':
      key = '姓名';
      break;
    case 'bank':
      key = '开户银行';
      break;
    case 'subbranch':
      key = '开户银行支行名称';
      break;
    case 'legalName':
      key = '法定代表人姓名';
      break;
    case 'groupname':
      key = '企业名称';
      break;
    case 'agentName':
      key = '代理人姓名';
      break;
    case 'bankNum':
      key = '对公账户';
      break;
  }
  if (!value) {
    callback(new Error(`请输入${key}`));
  } else {
    if (rule.field === 'name' || rule.field === 'legalName' || rule.field === 'agentName') {
      if (value.length < 2 || value.length > 20) {
        callback(new Error(`${key}长度在 2 到 20 个字符`));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 50) {
        callback(new Error(`${key}长度在 2 到 50 个字符`));
      } else {
        callback();
      }
    }
  }
};
// 长度校验 1 - 50
export const checkNameLength2 = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'bankAccount':
      key = '企业对公账户户名';
      break;
    case 'bankNum':
      key = '对公账户';
      break;
    case 'subbranch':
      key = '企业银行账号开户支行全称';
      break;
    case 'bank':
      key = '企业银行开户行名称';
      break;
  }
  if (!value) {
    callback(new Error(`请输入${key}`));
  } else {
    if (rule.field === 'bankNum') {
      if (!/^\d{1,50}$/.test(value)) {
        callback(new Error(`${key}长度在 2 到 50 个字符`));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 50) {
        callback(new Error(`${key}长度在 2 到 50 个字符`));
      } else {
        callback();
      }
    }
  }
};

// 长度校验 1 - 50  企业实名
export const checkNameLength3 = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'groupName':
      key = '企业名称';
      break;
    case 'legalName':
      key = '法人姓名';
      break;
    case 'bankAccount':
      key = '对公账户户名';
      break;
    case 'cardno':
      key = '对公账户';
      break;
    case 'subbranch':
      key = '开户行支行名称';
      break;
    case 'bank':
      key = '开户行名称';
      break;
    case 'legalIdno':
      key = '法人身份证号';
      break;
    case 'legalIdNo':
      key = '法人身份证号';
      break;
    case 'codeUSC':
      key = '统一社会信用代码';
      break;
    case 'codeORG':
      key = '组织机构代码';
      break;
    case 'selectedOptions':
      key = '开户行支行所在地';
      break;
  }
  if (!value) {
    if (rule.field === 'legalIdno') {
      callback();
    } else {
      callback(new Error(`请输入${key}`));
    }
  } else {
    if (rule.field === 'cardno') {
      if (!RegIsNum.test(value)) {
        callback(new Error(`${key}格式不正确`));
      } else {
        callback();
      }
    } else if (rule.field === 'legalName') {
      if (value.length < 2 || value.length > 30) {
        callback(new Error(`${key}长度在 2 到 30 个字符`));
      } else {
        callback();
      }
    } else if (rule.field === 'codeUSC') {
      if (!RegOrganCode3.test(value)) {
        callback(new Error(`${key}格式不正确`));
      } else {
        callback();
      }
    } else if (rule.field === 'codeORG') {
      if (!RegOrganCode.test(value)) {
        callback(new Error(`${key}格式不正确`));
      } else {
        callback();
      }
    } else if (rule.field === 'legalIdno') {
      if (!RegIdNum.test(value)) {
        callback(new Error(`${key}格式不正确`));
      } else {
        callback();
      }
    } else if (rule.field === 'legalIdNo') {
      if (!RegIdNum.test(value)) {
        callback(new Error(`${key}格式不正确`));
      } else {
        callback();
      }
    } else if (rule.field === 'selectedOptions') {
      if (value.length === 0) {
        callback(new Error(`${key}不能为空`));
      } else {
        callback();
      }
    } else {
      if (value.length < 2 || value.length > 60) {
        callback(new Error(`${key}长度在 2 到 60个字符`));
      } else {
        callback();
      }
    }
  }
};
// 香港
const RegHkId = /^[Hh]{1}([0-9]{10}|[0-9]{8})$/;
// 澳门
const RegAmId = /^[Mm]{1}([0-9]{10}|[0-9]{8})$/;
// 台湾
const RegTwId1 = /^[0-9]{8}$/;
const RegTwId2 = /^[0-9]{10}$/;
// 护照
const Reghuz = /^[A-Za-z0-9]+$/;
// 实名 id 校验
export const checkSmId = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'idNo':
      key = '身份证号码';
      break;
    case 'idNoHk':
      key = '内地通行证';
      break;
    case 'idNoAm':
      key = '内地通行证';
      break;
    case 'idNoTw':
      key = '台胞证';
      break;
    case 'idNoWj':
      key = '护照';
      break;
    case 'legalIdNo':
      key = '身份证号码';
      break;
    case 'legalIdNoHK':
      key = '内地通行证';
      break;
    case 'legalIdNoAM':
      key = '内地通行证';
      break;
    case 'legalIdNoTW':
      key = '台胞证';
      break;
    case 'legalIdNoWJ':
      key = '护照';
      break;
  }
  if (!value) {
    callback(new Error(`请输入${key}`));
  } else {
    if (rule.field === 'idNo' || rule.field === 'legalIdNo') {
      if (RegIdNum.test(value)) {
        callback();
      } else {
        callback(new Error(`请输入正确${key}`));
      }
    } else if (rule.field === 'idNoHk' || rule.field === 'legalIdNoHK') {
      if (RegHkId.test(value)) {
        callback();
      } else {
        callback(new Error(`请输入正确${key}`));
      }
    } else if (rule.field === 'idNoAm' || rule.field === 'legalIdNoAM') {
      if (RegAmId.test(value)) {
        callback();
      } else {
        callback(new Error(`请输入正确${key}`));
      }
    } else if (rule.field === 'idNoTw' || rule.field === 'legalIdNoTW') {
      if (RegTwId1.test(value) || RegTwId2.test(value)) {
        callback();
      } else {
        callback(new Error(`请输入正确${key}`));
      }
    } else if (rule.field === 'idNoWj' || rule.field === 'legalIdNoWJ') {
      if (Reghuz.test(value)) {
        callback();
      } else {
        callback(new Error(`请输入正确${key}`));
      }
    }
  }
};

// 企业 打款金额 校验
// 匹配数值类型，包括整数和浮点数
const RegCheckPay1 = /^[-\+]?\d+$/;
const RegCheckPay2 = /^[-\+]?\d+(\.\d+)?$/;
export const checkPay = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入金额'));
  } else {
    if (RegCheckPay1.test(value) || RegCheckPay2.test(value)) {
      callback();
    } else {
      callback(new Error('金额格式输入不正确'));
    }
  }
};
// 添加 印章
export const checkPersonSeal = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'personName':
      key = '姓名';
      break;
    case 'legalPersonName':
      key = '法人姓名';
      break;
    case 'groupName':
      key = '企业名称';
      break;
    case 'name':
      key = '印章名称';
      break;
    case 'Uses':
      key = '印章使用人';
      break;
    case 'Audits':
      key = '印章审计人';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (rule.field === 'personName' || rule.field === 'legalPersonName') {
      if (value.length < 2 || value.length > 18) {
        callback(new Error(`${key}长度在 2 到 18 个字符`));
      } else {
        callback();
      }
    } else if (rule.field === 'name') {
      if (value.length < 2 || value.length > 15) {
        callback(new Error(`${key}长度在 2 到 15 个字符`));
      } else {
        callback();
      }
    } else if (rule.field === 'groupName') {
      if (value.length < 2 || value.length > 60) {
        callback(new Error(`${key}长度在 2 到 60 个字符`));
      } else {
        callback();
      }
    } else {
      if (RegexPhone.test(value) || RegEmail.test(value)) {
        callback();
      } else {
        callback(new Error(`${key}格式为手机号或邮箱号`));
      }
    }
  }
};

// 印章上传 宽高校验 RegPINum
export const checkSealWH = (rule, value, callback) => {
  let key = '';
  switch (rule.field) {
    case 'width':
      key = '宽度';
      break;
    case 'height':
      key = '高度';
      break;
  }
  if (!value) {
    callback(new Error(`${key}不能为空`));
  } else {
    if (RegPINum.test(value)) {
      if (value <= 100) {
        callback();
      } else {
        callback(new Error('仅支持100mm以内的印章'));
      }
    } else {
      callback(new Error(`${key}格式错误`));
    }
  }
};

export const fileName = (rule, value, callback) => {
  if (!value) {
    callback(new Error('名称不能为空'));
  } else {
    if (value.length <= 20) {
      callback();
    } else {
      callback(new Error('名称不能超出20个字符'));
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/eleValidate.js